<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('luckyDrawReward.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('luckyDrawReward.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <Tabs @on-click="changeTab">
        <TabPane label="Current" icon="md-list">
          <ts-loading-banner :loading="loading">
            <current-event ref="CurrentEvent"></current-event>
          </ts-loading-banner>
        </TabPane>
        <TabPane label="History" icon="md-apps">
          <ts-loading-banner :loading="loading">
            <history-event ref="HistoryEvent"></history-event>
          </ts-loading-banner>
        </TabPane>
      </Tabs>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CurrentEvent from './current-event.vue'
import HistoryEvent from './history-event.vue'
import { debounce } from 'lodash'

export default {
  name: 'luckyDrawRewardIndex',
  components: {
    CurrentEvent,
    HistoryEvent
  },
  data () {
    return {
      loading: false,
      showForm: false,
      exporting: false
    }
  },
  async created () {
    await this.fetchFormViewData()
    // this.branch_id = [this.$store.state.authUser.user.default_branch.branch_id]
    this.getBranch()
    this.changeBranch()
    // this.location_id = [
    //   this.$store.state.authUser.user.default_location.location_id
    // ]
  },
  computed: {
    ...mapState('luckyDraw/luckyDrawReward', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawReward.search
      },
      set (newValue) {
        this.$store.commit('luckyDraw/luckyDrawReward/SET_SEARCH', newValue)
        this.$store.commit('luckyDraw/luckyDrawReward/RESET_CURRENT_PAGE')
      }
    },
    location_id: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawReward.location_id
      },
      set (newValue) {
        this.$store.commit(
          'luckyDraw/luckyDrawReward/SET_LOCATION_ID',
          newValue
        )
      }
    },
    branch_id: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawReward.branch_id
      },
      set (newValue) {
        this.$store.commit('luckyDraw/luckyDrawReward/SET_BRANCH_ID', newValue)
      }
    },
    locations: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawReward.locations
      },
      set (newValue) {
        this.$store.commit('luckyDraw/luckyDrawReward/SET_LOCATIONS', newValue)
      }
    },
    branchs: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawReward.branchs
      },
      set (newValue) {
        this.$store.commit('luckyDraw/luckyDrawReward/SET_BRANCHS', newValue)
      }
    }
  },
  methods: {
    ...mapActions('luckyDraw/luckyDrawReward', ['getFormViewData']),
    getBranch () {
      this.loading = true
      this.$store
        .dispatch('security/user/getBranchAssignedForFilter')
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async changeBranch () {
      this.loading = true
      this.location_id = []
      await this.$store
        .dispatch('security/user/getWarehouseAssignedForFilter', {
          branch_id: this.branch_id
        })
        .then(response => {
          this.locations = response.data.map(el => ({
            value: el.location_id,
            label: el.location_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async fetchFormViewData () {
      this.loading = true
      await this.getFormViewData({
        params: undefined,
        index: undefined
      }).finally(() => (this.loading = false))
    },
    changeTab (e) {
      if (e == 0) {
        this.$refs.CurrentEvent.fetchData()
      } else {
        this.$refs.HistoryEvent.fetchData()
      }
    },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('luckyDraw/luckyDrawReward/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
    location_id: debounce(function () {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('luckyDraw/luckyDrawReward/RESET_STATE')
    next()
  }
}
</script>
<style scoped>
.text-left {
  text-align: left;
}
</style>
